export default __webpack_public_path__ + "static/media/speech-therapy.84832cb3.png";